export default __webpack_public_path__ + "static/media/wishlist.ca98aef2.svg";